<div
  *ngIf="isLoading"
  class="d-flex justify-content-center align-items-center"
  style="height: 170px"
>
  <mat-spinner color="primary" mode="indeterminate"></mat-spinner>
</div>

<div class="painel-cte-detalhe" [hidden]="isLoading">
  <mat-card class="mb-0 border-0">
    <mat-card-header class="header-padrao">
      <mat-card-title>
        <div class="cte-header">
          <h3>
            Número CTE: {{detalhesCte?.numCTe}}
          </h3>
          <div>
            <button *ngIf="podeCriarRota"
              mat-flat-button
              color="primary"
              class="mx-1"
              matTooltip="Cadastrar Rota"
              (click)="abrirModalCadastroFrete(detalhesCte?.roteiroId)">
                <i class="fa fa-sync-alt"></i> Cadastrar Rota
            </button>

            <!-- <button *ngIf="detalhesCte?.statusId === 9"
              mat-flat-button
              #menuDownload="matMenuTrigger"
              color="secondary"
              class="mx-1"
              matTooltip="Baixar"
              [matMenuTriggerFor]="downloadMenu"
              [disabled]="isLoading || loadingWhileDownload">
                <span *ngIf="!loadingWhileDownload">
                  <i class="fa fa-file"></i> Download
                  <i [ngClass]="(menuDownload.menuOpen) ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
                </span>

                <span *ngIf="loadingWhileDownload" class="d-flex align-items-center">
                  Baixando...
                  <mat-spinner class="ml-2" strokeWidth="3" [diameter]="20"></mat-spinner> 
                </span>
            </button>

            <mat-menu #downloadMenu="matMenu" xPosition="before">
                <button mat-menu-item (click)="download('xml')">
                    <i class="fas fa-file-code mr-2"></i> Download XML
                </button>
                <button mat-menu-item (click)="download('pdf')">
                    <i class="fas fa-file-pdf mr-2"></i> Download PDF
                </button>
            </mat-menu> -->
            <mat-card *ngIf="regraEspecialAprovacao">
              <button
                mat-flat-button
                color="primary"
                class="mx-1 reprovar-reprocessar"
                matTooltip="Reprovar/Reprocessar CTE"
                (click)="aprovacaoCte(false)">
                  <i class="fa fa-thumbs-down"></i> Reprovar/Reprocessar CTE
              </button>
              <button
                mat-flat-button
                color="primary"
                class="mx-1 aprovar-emitir"
                matTooltip="Aprovar/Emitir CTE"
                (click)="aprovacaoCte(true)">
                  <i class="fa fa-thumbs-up"></i> Aprovar/Emitir CTE
              </button>
            </mat-card>
            <button *ngIf="podeReprocessar"
              mat-flat-button
              color="primary"
              class="mx-1"
              matTooltip="Reprocessar CTE"
              (click)="reprocessarCte()">
                <i class="fa fa-sync-alt"></i> Reprocessar CTE
            </button>
          </div>
        </div>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="d-flex flex-column">
        <h2>Situação: {{detalhesCte?.status}}</h2>
        <span *ngIf="detalhesCte?.erro?.descricao">
          Descrição: {{detalhesCte?.erro?.descricao}}
        </span>
      </div>
      <hr>
      <fieldset *ngIf="!canceladoOuErro">
        <legend>Etapa</legend>
        <div class="cte-etapas">
          <ng-container *ngFor="let etapa of etapas; let i = index">
            <div>
              <div class="circle"
                [class.notYet]="!etapas[i].data"
                [class.activeCircle]="etapas[i].data">
              </div>
              <div class="line" [ngClass]="{
                'line-left': !!i,
                'line-green': etapas[i].data}"
              ></div>
              <div class="line" [ngClass]="{
                'line-right': i !== etapas.length - 1,
                'line-green': etapas[i + 1]?.data}"
              ></div>
              <div class="d-flex flex-column align-items-center justify-content-center">
                <p class="statusText"><b>{{etapa.nome}}</b></p>
                <p><span class="statusTime">
                  {{(etapa.data | date: 'dd/MM/yyyy HH:mm:ss') || 'Aguardando...'}}
                </span></p>
              </div>
            </div>
          </ng-container>
        </div>
      </fieldset>
      <fieldset>
        <legend>DADOS CTE</legend>
        <div class="table-responsive">
          <table class="table-sm">
            <thead class="table-header">
              <th width="40%">Chave de acesso</th>
              <th width="15%">Número Cte</th>
              <th width="5%">Série</th>
              <th width="5%">PID</th>
              <th width="5%">CFOP</th>
              <th width="30%">Data Emissão</th>
            </thead>
            <tr>
              <td>{{detalhesCte?.chaveCTe}}</td>
              <td>{{detalhesCte?.numCTe}}</td>
              <td>{{detalhesCte?.serie}}</td>
              <td>{{detalhesCte?.valoresImpostos?.pid}}</td>
              <td>{{detalhesCte?.valoresImpostos?.cfop}}</td>
              <td>{{detalhesCte?.dataEmissao | date: 'dd/MM/yyyy - HH:mm:ss'}}</td>
            </tr>
          </table>
        </div>
      </fieldset>
      <fieldset class="entidades">
        <legend>ENTIDADES</legend>
        <div class="entidade-container">
          <div *ngFor="let entidade of detalhesCte?.entidades" class="table-responsive">
            <table class="table-sm">
              <thead class="table-header">
                <th colspan="4">
                  <span class="d-flex justify-content-between align-items-center">
                    {{entidade.tipoEntidade}}
                    <button *ngIf="podeEditarEntidade(entidade.tipoEntidade)"
                      mat-icon-button color="secondary"
                      (click)="abrirModalEntidade(entidade)">
                        <i class="fas fa-edit"></i>
                    </button>
                  </span>
                </th>
              </thead>
              <tr>
                <th colspan="2">Nome/Razão Social</th>
                <td colspan="2">{{entidade.razaoSocial}}</td>
              </tr>
              <tr>
                <th colspan="2">CNPJ</th>
                <td colspan="2">{{entidade.cgc}}</td>
              </tr>
              <tr>
                <th colspan="2">IE</th>
                <td colspan="2">{{entidade.insEstadual}}</td>
              </tr>
              <tr>
                <th colspan="2">UF</th>
                <td colspan="2">{{entidade.uf}}</td>
              </tr>
              <tr>
                <th colspan="2">Município</th>
                <td colspan="2">{{entidade.municipio}}</td>
              </tr>
              <tr>
                <th colspan="2">IBGE</th>
                <td colspan="2">{{entidade.ibge}}</td>
              </tr>
              <tr>
                <th colspan="2">Endereço</th>
                <td colspan="2">{{entidade.endereco}}</td>
              </tr>
              <tr>
                <th colspan="2">Bairro</th>
                <td colspan="2">{{entidade.bairro}}</td>
              </tr>
              <tr>
                <th colspan="2">CEP</th>
                <td colspan="2">{{entidade.cep}}</td>
              </tr>
            </table>
          </div>
        </div>
      </fieldset>
      <fieldset>
        <legend>VALORES / IMPOSTOS</legend>
        <div class="table-responsive mb-3">
          <table class="table-sm">
            <thead class="table-header">
              <th width="20%">Valor prestação serviço</th>
              <th width="20%">Valor a receber</th>
              <th width="20%">Frete peso</th>
              <th width="20%">Gris</th>
              <th width="20%">Advalorem</th>
            </thead>
            <tr>
              <td>{{detalhesCte?.valoresImpostos?.valorPrestacaoServico}}</td>
              <td>{{detalhesCte?.valoresImpostos?.valorReceber}}</td>
              <td>{{detalhesCte?.valoresImpostos?.fretePeso}}</td>
              <td>{{detalhesCte?.valoresImpostos?.gris}}</td>
              <td>{{detalhesCte?.valoresImpostos?.advalorem}}</td>
            </tr>
          </table>
        </div>
        <div class="table-responsive">
          <table class="table-sm">
            <thead class="table-header">
              <th width="10%">CST</th>
              <th width="15%">% de redução da BC</th>
              <th width="15%">Valor de Crédito</th>
              <th width="15%">Base ICMS</th>
              <th width="15%">Aliquota ICMS</th>
              <th width="15%">Valor ICMS</th>
              <th width="15%">Total Tributos</th>
            </thead>
            <tr>
              <td>{{detalhesCte?.valoresImpostos?.cst}}</td>
              <td>{{detalhesCte?.valoresImpostos?.percentualReducaoBC}}</td>
              <td>{{detalhesCte?.valoresImpostos?.valorCredito}}</td>
              <td>{{detalhesCte?.valoresImpostos?.baseICMS}}</td>
              <td>{{detalhesCte?.valoresImpostos?.aliquotaICMS}}</td>
              <td>{{detalhesCte?.valoresImpostos?.valorICMS}}</td>
              <td>{{detalhesCte?.valoresImpostos?.totalTributos}}</td>
            </tr>
          </table>
        </div>
      </fieldset>
      <fieldset class="eventos" *ngIf="detalhesCte?.eventos?.length > 0">
        <legend>SITUAÇÃO ATUAL</legend>
        <table class="table-sm">
          <thead class="table-header">
            <th width="20%">Tipo</th>
            <th width="40%">Evento</th>
            <th width="20%">Protocolo</th>
            <th width="20%">Data/Hora</th>
          </thead>
          <tr *ngFor="let evento of detalhesCte?.eventos">
            <td>{{evento.tipo}}</td>
            <td>{{evento.descricao}}</td>
            <td>{{evento.protocolo}}</td>
            <td>{{evento.data | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
          </tr>
        </table>
      </fieldset>
      <fieldset [hidden]="detalhesCte?.pedidosRelacionados?.length === 0">
        <legend>ITENS RELACIONADOS</legend>
        <button mat-flat-button
          #acaoCteNfe="matMenuTrigger"
          color="secondary"
          class="botaoAcaoCteNfe mx-1"
          matTooltip="Ações"
          [matMenuTriggerFor]="CteNfeAcao">
            <i class="fa fa-file"></i> Ações
            <i [ngClass]="(acaoCteNfe.menuOpen) ? 'fa fa-chevron-up' : 'fa fa-chevron-down'"></i>
        </button>
        <mat-menu #CteNfeAcao="matMenu" xPosition="before">
          <button mat-menu-item (click)="modalConfirmacaoRemoverPedidos()"
          [disabled]="pedidosSelecionados?.selected?.length === 0">
              Remover Selecionados
          </button>
        </mat-menu>
        <div>
          <div class="pedidos-selecionados" *ngIf="pedidosSelecionados?.selected?.length > 0">
            <h4 class="mb-1">Pedidos Selecionados:</h4>
            <mat-chip-list aria-label="Pedidos selecionados">
              <mat-chip *ngFor="let pedido of pedidosSelecionados?.selected"
                [removable]="true"
                (removed)="removePedidoLista(pedido)">
                  {{pedido.pedidoId}}
                  <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
            </mat-chip-list>
          </div>

          <table *ngIf="dataSource?.data?.length"
            mat-table
            class="mt-2"
            [dataSource]="dataSource">
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox *ngIf="!!temErroCteNfe"
                  (change)="$event ? masterToggle() : null"
                  [checked]="pedidosSelecionados.hasValue() && isAllSelected()"
                  [indeterminate]="pedidosSelecionados.hasValue() && !isAllSelected()">
                </mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let element">
                <mat-checkbox *ngIf="!!element.erronfe || !!element.errocte"
                  (click)="$event.stopPropagation()"
                  (change)="$event ? pedidosSelecionados.toggle(element) : null"
                  [checked]="pedidosSelecionados.isSelected(element)">
                </mat-checkbox>
                <span *ngIf="!element.erronfe || !element.errocte"
                  matTooltip="Pedido já processado">
                    <mat-icon style="color: #2ec500">check_circle_outline</mat-icon>
                  </span>
                </td>
              </ng-container>
              
              <ng-container matColumnDef="pedido">
                <th mat-header-cell *matHeaderCellDef> Pedido </th>
                <td mat-cell *matCellDef="let element"> {{element?.pedidoId}} </td>
              </ng-container>
              
              <ng-container matColumnDef="chaveCTe">
                <th mat-header-cell *matHeaderCellDef> Chave CTe </th>
                <td mat-cell *matCellDef="let element"> 
                  <mat-icon *ngIf="!!element?.errocte" style="color: #FF0033">error_outline</mat-icon>
                  {{element?.chaveCTe}}
                </td>
              </ng-container>
              
              <ng-container matColumnDef="chaveNFe">
                <th mat-header-cell *matHeaderCellDef> Chave NFe </th>
                <td mat-cell *matCellDef="let element">
                  <mat-icon *ngIf="!!element?.erronfe" style="color: #FF0033">error_outline</mat-icon>
                  {{element?.chaveNFe}}
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;">
            </tr>
          </table>
          <mat-paginator [pageSizeOptions]="[10, 20, 50]"></mat-paginator>
        </div>
      </fieldset>
    </mat-card-content>
  </mat-card>
</div>
